import { isNil } from 'lodash';

import { FeedbackReviewStatus } from 'shared/constants';
import { Status } from 'shared/types';
import { theme } from 'theme';

const placeholder = 'placeholder';
type Template = string[];
const fillGaps = (template: Template): string[] =>
  template.map((row, index) =>
    row
      .replace(/\s\./g, () => ` ${placeholder}${index}`)
      .replace(/\.\s/g, () => `${placeholder}${index} `),
  );

const sanitizeRow = (row: string): string => row?.replace(/\.|\[|\]/g, '');

const sanitizeTemplate = (template: Template): string[] => template.map(sanitizeRow);

const formatTemplate = (template: Template): string =>
  template.reduce((acc, row) => `${acc} "${row}"`, '').trim();

const resolveStatusColor = (status: Status | string, isBlocked?: boolean): string => {
  switch (status) {
    case Status.ACTIVE:
      return isBlocked ? theme.colors.fuzzyWuzzyBrown : theme.colors.emerald;
    case Status.INACTIVE:
      return theme.colors.mineShaftLightest;
    default:
      return theme.colors.mineShaftLightest;
  }
};

const resolveFeedbackStatusColor = (status: FeedbackReviewStatus | string): string => {
  switch (status) {
    case FeedbackReviewStatus.READ:
      return theme.colors.pictonBlue;
    case FeedbackReviewStatus.UNREAD:
      return theme.colors.gold;
    case FeedbackReviewStatus.SAVED:
      return theme.colors.emerald;
    default:
      return theme.colors.gold;
  }
};

const unsetOrPxVal = (val?: number) => (isNil(val) ? 'unset' : `${val}px`);

export {
  fillGaps,
  formatTemplate,
  resolveFeedbackStatusColor,
  resolveStatusColor,
  sanitizeRow,
  sanitizeTemplate,
  unsetOrPxVal,
};
